<template>
  <div>
    <GroupSummary
      data-test="visualization-summary"
      :initial-title="group.title"
      :group="group"
      :total-rows="totalRows"
      class="mx-3"
      @title-changed="$emit('title-changed', $event)"
      @column-clicked="(...args) => $emit('column-clicked', ...args)"
      @change-column-order="$emit('change-column-order')"
    />
    <div class="ms-5">
      <div
        v-for="([label, definition]) in definitions"
        :key="label"
      >
        <h5>{{ label }}</h5>
        <!-- eslint-disable vue/no-v-html -- definition is mdConverter.makeHtml (Showdown) output over server-trusted DBI/Data-Definitions field descriptions; renderedDefinition() injects bootstrap classes into emitted `<table>` -->
        <div
          class="text-muted me-4 text-justify"
          v-html="definition"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
      <div class="my-3 row" />
    </div>
    <img
      v-for="attachedImage in attachedImages"
      :key="attachedImage"
      :src="imageReference(attachedImage)"
      class="mx-5 my-2"
    >
    <div
      v-if="deployAll"
      class="position-relative ms-2 mb-1"
    >
      <div
        class="border rounded px-1"
        @dragover.stop.prevent="onDragOver"
        @dragleave="onDragLeave"
        @drop.stop.prevent="onDrop"
      >
        <div class="d-flex w-100">
          <div
            v-for="filename in uploadedImages"
            :key="filename"
            :title="imageReference(filename)"
            class="my-2 mx-1 border rounded d-flex align-items-start flex-column text-truncate position-relative"
            :style="{'width': '150px'}"
          >
            <img
              :src="imageReference(filename)"
              :style="{'width': '152px', 'height': '99px', 'object-fit': 'cover'}"
              class="rounded-top"
            >
            <i
              class="bi bi-x-circle-fill position-absolute text-danger rounded-circle bg-light"
              :style="{'right': '3px', 'top': '3px', 'cursor': 'pointer'}"
              title="Remove this image from server"
              @click="removeImage(filename)"
            />
            <div
              class="input-group d-flex"
              :style="{'height': '31px'}"
            >
              <div
                class="input-group-text flex-fill py-0"
                :style="{
                  'border-top-left-radius': '0!important',
                  'border-top-right-radius': '0!important',
                }"
              >
                <div class="flex-fill" />
                <label class="form-check-label">
                  Attach
                </label>
                <input
                  type="checkbox"
                  class="ms-2"
                  :checked="attachedImages.includes(filename)"
                  @input="saveImageAttachmentStatus(filename, $event.target)"
                >
                <div class="flex-fill" />
              </div>
            </div>
          </div>
          <div
            class="flex-fill mx-1 my-2 border rounded d-flex"
            :style="{
              'border-width': '3px!important',
              'border-color': 'rgb(0, 0, 0, 0.2)!important',
              'border-style': 'dashed!important',
              'border-radius': '15px!important',
              'height': '132px'
            }"
          >
            <div class="flex-fill" />
            <em class="my-auto text-muted">
              <template v-if="draggedOver">
                Drop to upload now <i class="bi bi-upload" />
              </template>
              <template v-else>Drag your images here</template>
            </em>
            <div class="flex-fill" />
          </div>
        </div>
      </div>
      <div
        v-if="processingImages"
        class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
        :style="{'background-color': 'rgb(255, 255, 255, .5)'}"
      >
        <div class="flex-fill" />
        <b-spinner />
        <div class="flex-fill" />
      </div>
    </div>
  </div>
</template>

<script>
  // Persistent per-group header (summary table + column definitions + image
  // drop-zone) shown above every visualization tab. Extracted from
  // FileColumnMostCommonValues so it can live inside each <b-tab> pane:
  // bootstrap-vue-next only registers <b-tab>s that are direct slot children,
  // so the old "non-tab markup + wrapper div inside <b-tabs>" broke tab
  // registration. Rendering identical content per pane is cheap because the
  // outer tabs are `lazy` (only the active pane mounts). All image-upload
  // state/logic stays in the parent and is passed in as data + fn props, so
  // behaviour is unchanged.
  import GroupSummary from './GroupSummary.vue';
  export default {
    components: {GroupSummary},
    props: {
      group: {type: Object, default: null},
      totalRows: {type: Number, default: null},
      deployAll: {type: Boolean, default: false},
      definitions: {type: Array, default: () => []},
      uploadedImages: {type: Array, default: () => []},
      attachedImages: {type: Array, default: () => []},
      draggedOver: {type: Boolean, default: false},
      processingImages: {type: Boolean, default: false},
      imageReference: {type: Function, default: () => ''},
      onDrop: {type: Function, default: () => {}},
      onDragOver: {type: Function, default: () => {}},
      onDragLeave: {type: Function, default: () => {}},
      removeImage: {type: Function, default: () => {}},
      saveImageAttachmentStatus: {type: Function, default: () => {}},
    },
    emits: ['title-changed', 'column-clicked', 'change-column-order'],
  };
</script>
